import Modal from "react-bootstrap/Modal";
import { useEffect, useState } from "react";
import SrvButton from "../../../components/global/SrvButton";
import { useSelector } from "react-redux";
import axios from "axios";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faXmark } from "@fortawesome/free-solid-svg-icons";
import Switch from "../../../components/ui/Switch";
import ErrorAdd from "../../../util/ErrorAdd";

function UserModalRemove(props) {
  const { show, onHide, model } = props;

  const [log, setLog] = useState(null);
  const [loading, setLoading] = useState(null);

  const [compliteTask, setCompliteTask] = useState(false);
  const [compliteTaskR, setCompliteTaskR] = useState(false);



  const stateSetting = useSelector((state) => state.setting);//Настройки приложения 

  //Очистка форм
  useEffect(() => {
    if (show === false) {
      setLog(null);
      setLoading(false);
    }

  }, [show]);

  function removeHandler() {
    setLoading(true);

    axios.post('/api_main/company/userServiceRemove', { ID_User: model.ID_User, ID_Service: process.env.REACT_APP_ID_SERVICE, ID_Company: stateSetting.user.ID_Company_Selected })
      .then((res) => {
        if (res.data.Status === 1) {

          axios.post('/api_tracker/other/userRemove', { ID_User: model.ID_User, Complite_Task: compliteTask, Complite_TaskR: compliteTaskR })
            .then((res1) => {
              if (res1.data.Status === 1) {
                onHide();
              }
              else {
                setLog(res1.data.Error);
                setLoading(false);
              }
            })
            .catch((err) => {
              setLog('Неизвестная ошибка!');
              setLoading(false);
              ErrorAdd(err, window.location.href);
            });

        }
        else {
          setLog(res.data.Error);
          setLoading(false);
        }
      })
      .catch((err) => {
        setLog('Неизвестная ошибка!');
        setLoading(false);
        ErrorAdd(err, window.location.href);
      });
  }


  return (
    <>
      <Modal show={show} onHide={onHide}>
        <Modal.Body>
          <div className="modal_close" onClick={onHide}><FontAwesomeIcon icon={faXmark} className="opacity-50" /></div>
          <div className="modal_title text-center mb-20">Удаление пользователя</div>
          <div className="text-center mb-20">Подтвердите удаление пользователя
            <br></br>
            <b>«{model.Name_User}»</b>
          </div>
          <div className="mb-20">
            <b>ВНИМАНИЕ!</b> <br></br>
            <u>пользователь будет удален:</u>
            <ul>
              <li>
                Из настроек проектов
              </li>
              <li>
                Из настроек переодических зазач
              </li>
              <li>
                Из черновиков задач
              </li>
            </ul>
          </div>
          <div className="mb-20">
            <Switch name="Завершить задачи" checked={compliteTask} handleChange={(e) => setCompliteTask(e)} />
            <Switch name="Завершить переодическиезадачи" checked={compliteTaskR} handleChange={(e) => setCompliteTaskR(e)} />
          </div>
          {log !== null && <div className="form_error text-center mt-15">{log}</div>}
          <div className="row mt-15">
            <div className="col-md-12 text-center">
              <SrvButton typeBtn="remove" onClick={() => removeHandler()} loading={loading} size={'lg'} />
            </div>
          </div>
        </Modal.Body>
      </Modal>
    </>
  );
}
export default UserModalRemove;
